import { useEffect } from "react"
import { Flex } from "../Flex"
import { useTabs } from "./Root"

export type PanelProps = Readonly<{
  /* A unique value that associates the tab with a panel. */
  value: string
  children: React.ReactNode | React.ReactNode[]
  onOpen?: () => void
}>

export const Panel = ({ value, children, onOpen }: PanelProps) => {
  const { state } = useTabs(`Panel`)

  useEffect(() => {
    if (value === state.selectedTab) {
      onOpen?.()
    }
  })

  return value === state.selectedTab ? <Flex width="100%">{children}</Flex> : null
}
